'use strict';

const isTabletDevice = require('./isTabletDevice');

const prepareDeferedImages = (html) => {
    $('.js-defered-image', html).each(function(i, el) {
        const imgSrc = $(el).data('src');
        const imgRetinaSrc = $(el).data('retina-src') || imgSrc;
        $(el).attr('src', isTabletDevice() ? imgRetinaSrc : imgSrc);
    });
};

module.exports = prepareDeferedImages;
